import { CommsPreferencesDTO } from '../model/communication-preferences.dto';

export function communicationPreferencesFormBuilder(
  commsPreferences: CommsPreferencesDTO,
  importantMarketingState: CommsPreferencesDTO,
  optionalMarketingState: CommsPreferencesDTO
) {
  const combinedMarketingState: CommsPreferencesDTO = {
    clientId: commsPreferences.clientId,
    automaticallySet: commsPreferences.automaticallySet,
    updatedBy: commsPreferences.updatedBy,
    essentialEmail: true,
    essentialPhone: true,
    essentialWhatsapp: importantMarketingState.essentialWhatsapp ?? commsPreferences.essentialWhatsapp,
    essentialPost: importantMarketingState.essentialPost ?? commsPreferences.essentialPost,
    nonEssentialEmail: optionalMarketingState.nonEssentialEmail ?? commsPreferences.nonEssentialEmail,
    nonEssentialPhone: optionalMarketingState.nonEssentialPhone ?? commsPreferences.nonEssentialPhone,
    nonEssentialWhatsapp: optionalMarketingState.nonEssentialWhatsapp ?? commsPreferences.nonEssentialWhatsapp,
    nonEssentialPost: optionalMarketingState.nonEssentialPost ?? commsPreferences.nonEssentialPost,
    mortgageMarketUpdateEmail:
      optionalMarketingState.mortgageMarketUpdateEmail ?? commsPreferences.mortgageMarketUpdateEmail,
    remortgageReminders: commsPreferences.remortgageReminders,
    preferenceNote: importantMarketingState.preferenceNote ?? commsPreferences.preferenceNote ?? ''
  };
  return combinedMarketingState;
}
